
import React from 'react';
import { Building, Home, DollarSign, UtensilsCrossed, Heart, Rocket } from 'lucide-react';
import ScrollReveal from '../ui/ScrollReveal';

const WhoWeWorkWith = () => {
  const industries = [
    {
      icon: <Home className="h-12 w-12 text-blue-600" />,
      title: "Home Builders & Contractors",
      description: "Showcase your craftsmanship with stunning project galleries and lead capture forms."
    },
    {
      icon: <Building className="h-12 w-12 text-green-600" />,
      title: "Real Estate Developers", 
      description: "Present your developments with immersive virtual tours and interactive floor plans."
    },
    {
      icon: <DollarSign className="h-12 w-12 text-purple-600" />,
      title: "Private Equity & Financial Services",
      description: "Professional, trust-building websites with secure client portals and compliance features."
    },
    {
      icon: <UtensilsCrossed className="h-12 w-12 text-orange-600" />,
      title: "Hospitality & Restaurants",
      description: "Mouth-watering menus, online reservations, and event booking systems that drive revenue."
    },
    {
      icon: <Heart className="h-12 w-12 text-red-600" />,
      title: "Nonprofits & Churches",
      description: "Inspiring websites that tell your story and make it easy for supporters to get involved."
    },
    {
      icon: <Rocket className="h-12 w-12 text-indigo-600" />,
      title: "Startups & SaaS Companies", 
      description: "Conversion-focused landing pages and product showcases that accelerate growth."
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <ScrollReveal>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-semibold mb-4">
              Who We Work With
            </h2>
          </ScrollReveal>
          <ScrollReveal delay={150}>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              We specialize in high-end web design for businesses that value quality and results.
            </p>
          </ScrollReveal>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {industries.map((industry, index) => (
            <ScrollReveal key={index} delay={150 * (index % 3)}>
              <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-gray-50 to-white border border-gray-100 hover:border-gray-200 hover:shadow-lg transition-all duration-300 group">
                <div className="mb-6 flex justify-center">
                  <div className="p-4 bg-white rounded-full shadow-md group-hover:shadow-lg transition-shadow duration-300">
                    {industry.icon}
                  </div>
                </div>
                <h3 className="text-xl font-semibold mb-4 text-gray-900">
                  {industry.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {industry.description}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoWeWorkWith;
